import { RootState } from '@reducers';

export const selectCarQuoteResultPage = (state: RootState) => state.carQuoteResultPageReducer;
